import React from 'react'
import { Link } from 'newComponents'
import './styles.scss'

const CategoryList = ({ categories, className }) => {
  const mainCategory = categories ? categories[0] : null

  const hasCatUid = mainCategory?.category?.uid
  const catUid = hasCatUid || 'best-practices'

  const categoryUidToName = {
    podcast: 'PODCASTS',
    'team-news': 'TEAM & NEWS'
  }

  // if (!catUid) return null
  const formattedCategory = hasCatUid
    ? categoryUidToName[catUid] || catUid.toUpperCase().replace(/-/g, ' ')
    : 'BEST PRACTICES'

  return (
    <div className={`categories-list ${className || ''}`}>
      {/* {categories.map((cat) => { */}
      {/* const catUid = cat?.category?.uid
        if (!catUid) return null
        const formattedCategory = cat.category.uid.toUpperCase().replace(/-/g, ' ')
        return ( */}
      <Link to={`/blog/category/${catUid}`} className="category" key={formattedCategory}>
        <span>{formattedCategory}</span>
      </Link>
      {/* ) */}
      {/* })} */}
    </div>
  )
}

export default CategoryList
